export default "__VITE_ASSET__lsDvNqM4__"